<div id="inner-create-container" class="create-page container-fluid pb-6">
  <div class="h-100 container">
    <div class="h-100 justify-content-center align-items-center row">
      <div class="col-lg-6">
        <div class="card">
          <h4 class="card-title mt-4">Create Password</h4>
          <div class="card-body">
            <!-- Forms Section -->

            <form [formGroup]="createPwForm" (ngSubmit)="handleSubmit()" #ngForm="ngForm">
              <div class="form-group col-md-12 pb-2">
                <label for="newPw" class="required">Password</label>

                <div class="input-group">
                  <input [type]="showPassword ? 'text' : 'password'" maxlength="250" formControlName="newPw"
                    class="form-control" placeholder="Enter New Password" required
                    [ngClass]="{'invalid' : newPw.invalid && formSubmitted}" />
                    <div class="input-group-append" (click)="togglePassword('password')">
                      <span class="input-group-text h-100"> <fa-icon
                      [icon]="showPassword ? faEye : faEyeSlash"></fa-icon></span>
                    </div>
                  </div>
                </div>
                @if (formSubmitted && newPw.invalid) {
                  <div class="alert alert-danger m-1">
                    Enter a valid new password.
                  </div>
                }
                <div class="form-group col-md-12 pb-2 mt-3">
                  <label for="confirmPw" class="required">Reenter Password</label>

                  <div class="input-group">
                    <input maxlength="250" class="form-control" placeholder="Confirm new password"
                      formControlName="confirmPw" [type]="showConfirmPassword ? 'text' : 'password'" required
                      [ngClass]="{'invalid' : confirmPw.invalid && formSubmitted}" />
                      <div class="input-group-append" (click)="togglePassword('confirm')">
                        <span class="input-group-text h-100"> <fa-icon
                        [icon]="showConfirmPassword ? faEye : faEyeSlash"></fa-icon></span>
                      </div>
                    </div>
                  </div>

                  @if (formSubmitted && confirmPw.errors?.['passwordMismatch']) {
                    <div class="alert alert-danger mt-3">
                      Passwords do not match.
                    </div>
                  }

                  <div class="row">
                    <div class="col mt-2">
                      <span><b>Password requirements</b></span>
                      <span class="d-flex mt-2 pb-3">
                        Passwords must be at least 8 characters in length and
                        contain at least 1 of each of the following character
                        types:
                      </span>
                      <ul>
                        <li>Lower case letters (i.e. a-z)</li>
                        <li>Upper case letters (i.e. A-Z)</li>
                        <li>Numbers (i.e. 0-9)</li>
                        <li>
                          Special Characters (i.e. !&#64;#$%^*()_~-=`{{
                          "[]:<>?,.//"
                          }})
                        </li>
                        <li>
                          Note: Special Characters & and + are not permitted
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div ng-controller="Ctrl as ctrl">
                    <toaster-container
                    toaster-options="{'toaster-id': 1, 'animation-class': 'toast-top-left'}"></toaster-container>

                    <button type="submit" class="btn btn-primary mt-4">
                      Confirm and Create
                    </button>
                  </div>
                  @if (resetFailed) {
                    <div class="py-1 text-center">
                      <p>Failed to reset.</p>
                    </div>
                  }

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>